import React from 'react';
import PropTypes from 'prop-types';
import { useRouter } from 'next/router';
import { parseUrl } from 'query-string';
import { buildAzUrl } from '../../helpers';
import BlazeLink from '../../../BlazeLink';
const ListHeader = ({
  name,
  listAggregations,
  azFilter
}) => {
  const router = useRouter();
  const {
    asPath
  } = router;
  const {
    url,
    query
  } = parseUrl(asPath);
  const allHref = buildAzUrl(query, name, '', url);
  return /*#__PURE__*/React.createElement("div", {
    className: "az_list_filter flex"
  }, /*#__PURE__*/React.createElement(BlazeLink, {
    ariaLabel: "Show all",
    className: `az_list_filter_option${!azFilter ? ' selected' : ''} flex-grow`,
    href: allHref,
    onClick: e => {
      e.preventDefault();
      return router.push('/Resolver', allHref, {
        shallow: true
      });
    }
  }, "ALL"), listAggregations.map(({
    key,
    doc_count: count
  }) => {
    if (!count) return /*#__PURE__*/React.createElement("span", {
      key: key,
      className: "az_list_filter_option no_results flex-grow"
    }, key);
    const href = buildAzUrl(query, name, key, url);
    const isSelected = azFilter === key.toLowerCase();
    const className = `az_list_filter_option${isSelected ? ' selected' : ''} flex-grow`;
    return /*#__PURE__*/React.createElement(BlazeLink, {
      ariaLabel: `Filter by ${key}`,
      key: key,
      className: className,
      href: href,
      onClick: e => {
        e.preventDefault();
        return router.push('/Resolver', href, {
          shallow: true
        });
      }
    }, key);
  }));
};
ListHeader.propTypes = {
  listAggregations: PropTypes.array.isRequired,
  name: PropTypes.string.isRequired,
  azFilter: PropTypes.string.isRequired
};
export default ListHeader;
//# sourceMappingURL=ListHeader.js.map